__turbopack_context__.v({
  "img": "styles-module__uFY2pq__img",
  "newBlockService": "styles-module__uFY2pq__newBlockService",
});
